import React from "react";

const QuizGradients = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      {/* Color 1: Red (#EF4444) */}
      <linearGradient id="bgGrad1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FEE2E2" />
        <stop offset="100%" stopColor="#FECACA" />
      </linearGradient>
      <linearGradient id="iconGrad1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FCA5A5" />
        <stop offset="100%" stopColor="#EF4444" />
      </linearGradient>

      {/* Color 2: Teal (#14B8A6) */}
      <linearGradient id="bgGrad2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#CCFBF1" />
        <stop offset="100%" stopColor="#99F6E4" />
      </linearGradient>
      <linearGradient id="iconGrad2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5EEAD4" />
        <stop offset="100%" stopColor="#14B8A6" />
      </linearGradient>

      {/* Color 3: Amber (#F59E0B) */}
      <linearGradient id="bgGrad3" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FEF3C7" />
        <stop offset="100%" stopColor="#FDE68A" />
      </linearGradient>
      <linearGradient id="iconGrad3" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FCD34D" />
        <stop offset="100%" stopColor="#F59E0B" />
      </linearGradient>

      {/* Color 4: Purple (#8B5CF6) */}
      <linearGradient id="bgGrad4" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#EDE9FE" />
        <stop offset="100%" stopColor="#DDD6FE" />
      </linearGradient>
      <linearGradient id="iconGrad4" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#A78BFA" />
        <stop offset="100%" stopColor="#8B5CF6" />
      </linearGradient>

      {/* Color 5: Pink (#EC4899) */}
      <linearGradient id="bgGrad5" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FCE7F3" />
        <stop offset="100%" stopColor="#FBCFE8" />
      </linearGradient>
      <linearGradient id="iconGrad5" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F9A8D4" />
        <stop offset="100%" stopColor="#EC4899" />
      </linearGradient>
    </defs>
  </svg>
);

export default QuizGradients;
